import React from 'react'; 

const NoItemsToDisplay = () => ( 
  <div className="alert alert-warning text-center">
    Sorry, no items found.
  </div>
);

export default NoItemsToDisplay;



// WEBPACK FOOTER //
// ./src/features/finance/NoItemsToDisplay.jsx